import React from "react";
import officeimg from "../../../image/udoka the web developer.jpg"
import { Link } from "react-router-dom";
import { useEffect } from "react";
import Type from "../../types/type";
import Aos from "../../aos/aos";
// import Mycv from "../../../files/"
const Hero = () => {


    useEffect(() => {
        Aos(1000)
    }, [])
    useEffect(() => {
        Type(['Hello!', 'I am OTSU UDOKA', 'A full-stack web developer', 'With 3+ years experience', 'Hire me now!'], 200, 100)
    }, [])
    return (
        <div className="md:h-full h-[50%] flex items-center w-full md:w-[50%] relative">
            <img src={officeimg} alt="officeimg" className=" w-full h-full opacity-50 rounded" />
            <div className="flex flex-col justify-center items-center md:space-y-8 space-y-4 absolute px-2 md:mt-20 ">
                <div className="flex items-center space-x-2">
                    <div className="text-white backdrop-blur h-[40px] font-extrabold md:text-4xl text-md font-mono typing-element">

                    </div>
                    <div className="type-cursor text-yellow-500 h-[40px] md:text-4xl text-xl">I</div>
                </div>

                <div className="text-lg text-white/80 font-bold text-justify font-sans md:px-12" data-aos="fade-up">
                    <div className="hidden md:block">I specialize in creating and revamping responsive website applications with a
                        professional and cost-effective approach. I offer comprehensive
                        website services, catering to various needs. I am available round-the-clock
                        for any project, prioritizing client satisfaction above all. Feel free to reach out
                        to me to discuss your exciting project.</div>
                    <div className="md:hidden text-sm">Do you want awesome design on your website or web applications? I gives the best of all!</div>
                </div>
                <div className="w-full flex justify-between md:px-40 px-8 py-4">
                    <Link reloadDocument  to="/hireMe" className="bg-yellow-500 py-2 px-2 text-white rounded-lg hover:bg-black/30 hover:border" data-aos="fade-left">Hire Me</Link>
                    <a href="/otsu udoka web cv.pdf" download className="bg-yellow-500 py-2 px-2 text-white rounded-lg hover:bg-black/30 hover:border" data-aos="fade-right">Download Resume</a>
                </div>
            </div>
        </div>
    );
}

export default Hero;